<template>
  <div class="flex flex-col min-h-full">
    <div class="flex-none bg-blue-900 p-4 lg:p-12">
      <div class="w-full mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center">
          <h4 class="text-white font-bold">Production orders</h4>

          <div class="flex md:ml-auto mt-4 md:mt-0">
            <div class="glue-h">
              <BaseButton primary :outline="!isTableView" @click="setTableView">
                Table List
              </BaseButton>
              <BaseButton primary :outline="!isKanbanView" @click="setKanbanView">
                Kanban board
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex-1 lg:px-12 -mt-12 h-0"
      :class="[
        {
          'lg:pb-12': isTableView,
          'px-4': isTableView,
          'pb-4': isTableView,
        },
      ]"
    >
      <div
        class="w-full mx-auto"
        :class="[
          {
            'h-full': isKanbanView,
          },
        ]"
      >
        <div
          class="space-y-16"
          :class="[
            {
              'h-full': isKanbanView,
            },
          ]"
        >
          <VKanbanBoard
            v-if="isKanbanView"
            :last-edited-production-order-item-id="lastEditedProductionOrderItemId"
            :lists="statuses"
            @production-order-item:view="viewProductionOrderItem"
          >
            <template #default="productionOrderItemListProps">
              <KanbanBoardProductionOrderItemList
                :key="productionOrderItemListProps.list"
                :ref="productionOrderItemListProps.list"
                :production-order-item-status="productionOrderItemListProps.list"
                :filters="queryFilters"
                :last-edited-production-order-item-id="lastEditedProductionOrderItemId"
                :fetch-production-orders="fetchProductionOrders"
                @production-order-item:view="viewProductionOrderItem"
                @production-order-list:updated="refreshLists"
              />
            </template>
          </VKanbanBoard>

          <ProductionOrderList
            v-else
            :last-edited-production-order-item-id="lastEditedProductionOrderItemId"
            @production-order-item:view="viewProductionOrderItem"
          />
        </div>
      </div>
    </div>

    <portal v-if="selectedProductionOrderItemId" to="app-modal">
      <OrderItemModal
        :order-item-id="selectedProductionOrderItemId"
        @order-item-modal:closed="afterModalClosed"
      />
    </portal>
  </div>
</template>

<script>
import { productionOrdersClient } from '@/api/clients';
import VKanbanBoard from '@/components/Common/VKanbanBoard.vue';
import ProductionOrderList from '@/components/ProductionOrders/ProductionOrderList.vue';
import KanbanBoardProductionOrderItemList from '@/components/ProductionOrders/KanbanBoardProductionOrderItemList.vue';
import OrderItemModal from '@/components/OrderItems/OrderItemModal.vue';

const VIEW_TABLE = 'table';
const VIEW_KANBAN = 'kanban';

const STATUS_DRAFT = 'draft';
const STATUS_PENDING = 'pending';
const STATUS_IN_PROGRESS = 'in progress';
const STATUS_IN_REVIEW = 'in review';
const STATUS_COMPLETED = 'completed';

export default {
  name: 'ProductionOrders',

  components: {
    ProductionOrderList,
    VKanbanBoard,
    KanbanBoardProductionOrderItemList,
    OrderItemModal,
  },

  data: () => ({
    view: VIEW_KANBAN,
    lastEditedProductionOrderItemId: null,
    selectedProductionOrderItemId: null,
    filters: {},
    queryFilters: {},
    statuses: [
      STATUS_DRAFT,
      STATUS_PENDING,
      STATUS_IN_PROGRESS,
      STATUS_IN_REVIEW,
      STATUS_COMPLETED,
    ],
    filtersVisible: false,
  }),

  computed: {
    isKanbanView() {
      return this.view === VIEW_KANBAN;
    },
    isTableView() {
      return this.view === VIEW_TABLE;
    },
  },

  watch: {
    $route: 'updateQueryFilters',
  },

  created() {
    this.fetchFilters();
  },

  methods: {
    setTableView() {
      this.view = VIEW_TABLE;
    },
    setKanbanView() {
      this.view = VIEW_KANBAN;
    },
    async fetchFilters() {
      try {
        const response = await productionOrdersClient.filters();
        this.filters = response.data.data;
      } catch (error) {
        /** handle error */
      }
    },

    async fetchProductionOrders(params) {
      return productionOrdersClient.list(params);
    },

    updateQueryFilters({ query }) {
      const { filter = {} } = query;

      this.queryFilters = { ...filter };
    },

    viewProductionOrderItem(productionOrderItemId) {
      this.lastEditedProductionOrderItemId = productionOrderItemId;
      this.selectedProductionOrderItemId = productionOrderItemId;
    },

    refreshLists(lists) {
      lists.forEach((list) => {
        const refs = this.$refs[list];

        if (!refs) {
          return;
        }

        if (Array.isArray(refs)) {
          refs.forEach((ref) => {
            ref.refresh();
          });
          return;
        }

        refs.refresh();
      });
    },

    afterModalClosed() {
      this.selectedProductionOrderItemId = null;
    },
  },
};
</script>
